import Axios from 'axios'
import Mock from '@/API/mock'
const Ajax = {
    _mock: Mock,
    _aspect: {
        start() {},
        finish() {},
        error() {}
    },
    initAxios(serverRoot = '/', headers) {
        if (!this.axios) {
            const _axios = Axios.create({
                baseURL: serverRoot,
                timeout: 50000,
                headers,
                // 跨域带cookie
                withCredentials: true
            })
            _axios.interceptors.request.use(config => {
                console.warn('request interceptors',config)
                this._aspect.start()
                return config
            }, error => {
                console.warn('error interceptors')
                this._aspect.error(error)
                return Promise.reject(error)
            })
            _axios.interceptors.response.use(response => {
                console.warn('response interceptors', response)
                var rs = response.data
                this._aspect.finish(rs)
                if (rs instanceof Blob) {
                    return response
                } else {
                    // 只返回数据
                    return rs
                }
            }, error => {
                console.warn('error interceptors')
                this._aspect.error(error)
                return Promise.reject(error)
            })
            _axios.all = Axios.all
            _axios.spread = Axios.spread
            this.axios = _axios
        }
    },
    get(url, params, scb, ecb) {
        return this.send({
            method: 'get',
            url,
            params
        }, scb, ecb)
    },
    post(url, data, scb, ecb) {
        return this.send({
            method: 'post',
            url,
            data
        }, scb, ecb)
    },
    delete(url, params, scb, ecb) {
      return this.send({
        method: 'delete',
        url,
        params
      }, scb, ecb)
    },
    send(config, scb, ecb) {
        var promise = this.mock(config)
        // 如果模拟数据中没有则去请求数据
        if (!promise) {
            promise = this.axios(config)
        }
        // debugger
        if (scb) {
            promise.then(scb).catch(ecb)
        } else {
            return promise
        }
    },
    mock({method,url,data,params}) {
      console.log('mock 解析:', method, url, data || params || '')
      var jk = this._mock[url]
      if (jk) {
        var handler = jk[method]
        if (handler) {
          this._aspect.start()
          var promise = new Promise((resolve, reject) => {
            setTimeout(() => {
              var rs = handler(data)
              resolve(rs)
              this._aspect.finish(rs)
            }, 1000)
          })
          return promise
        }
      }
      return false
    },
    
}
Ajax.initAxios('heyushuo');
export default Ajax



// WEBPACK FOOTER //
// ./src/Common/API/ajax.js